import React, { type ComponentProps } from 'react';
import { Form } from 'ALIASED-antd';
import type { TRegistrationForm } from './TRegistrationForm';

type RegistrationFormProps = ComponentProps<typeof Form<TRegistrationForm>>;

const defaultProps: Partial<RegistrationFormProps> = {
  name: 'registration-form',
  scrollToFirstError: { focus: true, block: 'center' },
  validateMessages: {
    required: '${label} is required'
  }
};

export const RegistrationForm = (props: RegistrationFormProps) => (
  <Form<TRegistrationForm> {...{ ...defaultProps, ...props }} />
);
